<template>
    <div>
    </div>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'

export default {
    name: "DashboardVendors",
    setup() {

    },
    data() {
        return {

        }
    },
    components: {

    },
    methods: {

    },
    computed: {

    },
    mounted() {

    }
}
</script>
